import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HomePageRoutingModule } from './home-routing.module';

import { HomePage } from './home.page';
import { TranslateModule } from '@ngx-translate/core';
import { DateFormatPipe } from 'src/app/utils/pipes-utils/date_formatter';
import { FooterModule } from 'src/app/widgets/footer-component/header-footer.module';
import {
  GetFirstActivityLevelPipe,
  IsHarvestingActivity,
} from 'src/app/utils/pipes-utils/activity_pipe';
import { LanguageComponent } from './widgets/language/language.component';
import { ProductAnimalInterfaceComponent } from './widgets/product-animal-interface/product-animal-interface.component';
import { FarmModule } from '../farm/farm.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FilterWidgetComponent } from './widgets/filter-widget/filter-widget.component';
import { SharedModule } from 'src/app/modules-config/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { CashflowModule } from '../cashflow/cashflow.module';
import { GoodsModule } from '../goods/goods.module';
import { PartnerModule } from '../partner/partner.module';
import { SkeletonLoaderModule } from 'src/app/widgets/skeleton-loader/skeleton-loader.module';
import { EmptyListModule } from 'src/app/widgets/empty-list/empty-list.module';
import { AnalysisPageModule } from './analysis/analysis.module';
import { EffectsModule } from '@ngrx/effects';
import { CashflowEffect } from 'src/app/utils/states-management/effects/cashflow.effect';
import { OwnerEffect } from 'src/app/utils/states-management/effects/owner.effect';
import { CalculetteComponentComponent } from './calculette-component/calculette-component.component';
import { AnalysisInputsComponent } from './cashflow/analysis-inputs/analysis-inputs.component';
import { ModalCashflowEntryListComponent } from './modal-cashflow-entry-list/modal-cashflow-entry-list.component';
import { DeleteAccountComponent } from 'src/app/components/delete-account/delete-account.component';
import { FamilyAccessComponent } from 'src/app/components/family-access/family-access.component';
import { ProductionPerdidasProductsStatsComponent } from './widgets/production-perdidas-products-stats/production-perdidas-products-stats.component';
import { SummaryComponent } from './summary/summary.component';
import { CasflowSummaryComponent } from './widgets/casflow-summary/casflow-summary.component';
import { BankAccountWidgetComponent } from './widgets/bank-account-widget/bank-account-widget.component';
import { CardSummaryRegroupedComponent } from './widgets/card-summary-regrouped/card-summary-regrouped.component';
import { ShortcutsComponent } from 'src/app/widgets/shortcuts/shortcuts.component';
import { PreProgComponent } from '../programs/pre-prog/pre-prog.component';
import { ProgramsComponent } from '../programs/programs.component';
import { ProgramsModalComponent } from '../programs/programs-modal/programs-modal.component';
import { RatingModalComponent } from 'src/app/widgets/rating-modal/rating-modal.component';
import { BookComponent } from './cashflow/book/book.component';
import { DateFilterModalComponent } from './widgets/date-filter-modal/date-filter-modal.component';
import { CoffeeSalesComponent } from '../coffee-sales/coffee-sales.component';
import { AmbassadorCofidentialityComponent } from '../ambassador-cofidentiality/ambassador-cofidentiality.component';
import { CashflowSignleEntrySummaryComponent } from './cashflow/cashflow-signle-entry-summary/cashflow-signle-entry-summary.component';
import { CashflowSummaryDiaryComponent } from './cashflow/cashflow-summary-diary/cashflow-summary-diary.component';
import { PensionPlanTrackerComponent } from './widgets/pension-plan-tracker/pension-plan-tracker.component';
import { PensionPlanUpdatederComponent } from './widgets/pension-plan-updateder/pension-plan-updateder.component';
import { PensionPlanFormComponent } from './widgets/pension-plan-form/pension-plan-form.component';
import { CashflowSelectorComponent } from './widgets/cashflow-selector/cashflow-selector.component';
import { ProductionSalesOtherComponent } from './cashflow/production-sales-other/production-sales-other.component';
import { ProductCashflowListItemComponent } from './widgets/product-cashflow-list-item/product-cashflow-list-item.component';
import { AccountingEntryCategorieStatsComponent } from './widgets/accounting-entry-categorie-stats/accounting-entry-categorie-stats.component';
import { CoffeProductionViewComponent } from './coffee-production-view/coffee-production-view.component';
import { CoffeeTypeSelectorComponent } from './widgets/coffee-type-selector/coffee-type-selector.component';
import { CoffeeKpisComponent } from './kpis/coffee-kpis/coffee-kpis.component';
import { ProductionSalesOtherHeaderComponent } from './cashflow/production-sales-other-header/production-sales-other-header.component';
import { LineChartExpensesChartComponent } from './widgets/line-chart-expenses-chart/line-chart-expenses-chart.component';
import { CategoriesSelectionPopoverComponent } from './widgets/categories-selection-popover/categories-selection-popover.component';
import { AnalysisWorkforceComponent } from './cashflow/analysis-workforce/analysis-workforce.component';
import { AnalysisHarvestComponent } from './cashflow/analysis-harvest/analysis-harvest.component';
import { AnalysisInsumosBarchartComponent } from './cashflow/analysis-insumos-barchart/analysis-insumos-barchart.component';
import { AnalysesFilterComponent } from './cashflow/filters/analyses-filter/analyses-filter.component';
import { WorkdayAnalyseFitlerComponent } from './cashflow/filters/workday-analyse-fitler/workday-analyse-fitler.component';
import { KpisFiltersComponent } from './cashflow/filters/kpis-filters/kpis-filters.component';
import { InputsFilterComponent } from './cashflow/filters/inputs-filter/inputs-filter.component';
import { DateFilterComponent } from 'src/app/widgets/date-filter/date-filter.component';
import { AnalysisInputsUsageComponent } from './cashflow/analysis-inputs-usage/analysis-inputs-usage.component';
import { QuestionAnswersComponent } from './question-answers/question-answers.component';
import { AccordionQuestionComponent } from 'src/app/widgets/accordion-question/accordion-question.component';
import { FooterComponentComponent } from 'src/app/widgets/footer-component/footer-component.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    TranslateModule.forChild(),
    FooterModule,
    FarmModule,
    MatTabsModule,
    SharedModule,
    CommonModule,
    FormsModule,
    IonicModule,
    MatExpansionModule,
    FooterModule,
    CashflowModule,
    GoodsModule,
    MatTabsModule,
    PartnerModule,
    SkeletonLoaderModule,
    EmptyListModule,
    EffectsModule.forFeature([CashflowEffect, OwnerEffect]),
    AnalysisPageModule,
  ],

  providers: [DateFormatPipe, GetFirstActivityLevelPipe, IsHarvestingActivity],
  declarations: [
    HomePage,
    LanguageComponent,
    ProductAnimalInterfaceComponent,
    FilterWidgetComponent,
    CalculetteComponentComponent,
    AnalysisInputsComponent,
    ModalCashflowEntryListComponent,
    DeleteAccountComponent,
    FamilyAccessComponent,
    ProductionPerdidasProductsStatsComponent,
    SummaryComponent,
    CasflowSummaryComponent,
    BankAccountWidgetComponent,
    CardSummaryRegroupedComponent,
    ShortcutsComponent,
    PreProgComponent,
    ProgramsComponent,
    ProgramsModalComponent,
    RatingModalComponent,
    BookComponent,
    DateFilterModalComponent,
    CoffeeSalesComponent,
    AmbassadorCofidentialityComponent,
    CashflowSignleEntrySummaryComponent,
    CashflowSummaryDiaryComponent,
    PensionPlanTrackerComponent,
    PensionPlanUpdatederComponent,
    PensionPlanFormComponent,
    CashflowSelectorComponent,
    ProductionSalesOtherComponent,
    ProductCashflowListItemComponent,
    AccountingEntryCategorieStatsComponent,
    CoffeProductionViewComponent,
    CoffeeTypeSelectorComponent,
    CoffeeKpisComponent,
    ProductionSalesOtherHeaderComponent,
    LineChartExpensesChartComponent,
    CategoriesSelectionPopoverComponent,
    AnalysisWorkforceComponent,
    AnalysisHarvestComponent,
    AnalysisInsumosBarchartComponent,
    AnalysesFilterComponent,
    WorkdayAnalyseFitlerComponent,
    KpisFiltersComponent,
    InputsFilterComponent,
    DateFilterComponent,
    AnalysisInputsUsageComponent,
    QuestionAnswersComponent,
    AccordionQuestionComponent
  ],
  exports: [
    CalculetteComponentComponent,
    KpisFiltersComponent,
    ModalCashflowEntryListComponent,
    DeleteAccountComponent,
    FamilyAccessComponent,
    SummaryComponent,
    CasflowSummaryComponent,
    BankAccountWidgetComponent,
    CardSummaryRegroupedComponent,
    ShortcutsComponent,
    PreProgComponent,
    ProgramsComponent,
    ProgramsModalComponent,
    RatingModalComponent,
    BookComponent,
    DateFilterModalComponent,
    CoffeeSalesComponent,
    AmbassadorCofidentialityComponent,
    CashflowSignleEntrySummaryComponent,
    CashflowSummaryDiaryComponent,
    PensionPlanTrackerComponent,
    PensionPlanUpdatederComponent,
    PensionPlanFormComponent,
    CashflowSelectorComponent,
    ProductCashflowListItemComponent,
    AccountingEntryCategorieStatsComponent,
    ProductionPerdidasProductsStatsComponent,
    CoffeProductionViewComponent,
    CoffeeTypeSelectorComponent,
    CoffeeKpisComponent,
    ProductionSalesOtherHeaderComponent,
    LineChartExpensesChartComponent,
    FooterComponentComponent,
    AnalysisWorkforceComponent,
    AnalysisHarvestComponent,
    AnalysisInputsComponent,
    AnalysisInsumosBarchartComponent,
    AnalysesFilterComponent,
    AnalysisInsumosBarchartComponent,
    WorkdayAnalyseFitlerComponent,
    InputsFilterComponent,
    AnalysisInputsUsageComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePageModule {}
